import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import validator from 'validator';

export default function CreateUserDialog({ open, setOpen, handleCreateUser }) {

    const [emailValue, setEmailValue] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);

    const validateEmail= (email) => {
        const isValidEmail = validator.isEmail(email)
        return isValidEmail;
    }

    const [password, setPassword] = useState('');
    const [isValidPassword, setIsValidPassword] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitAndClose = async (event) => {
        event.preventDefault();
        if(!validateEmail(emailValue) || password.length < 6){
            return;
        }
        await handleCreateUser(event);
        setOpen(false);
        setEmailValue('');
        setPassword('');
    };
    
    return (
        <div>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Create User</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Enter the new user's credentials here.
            </DialogContentText>
            <Box component="form" onSubmit={handleSubmitAndClose} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={emailValue}
                    onChange={(e) => {
                        setEmailValue(e.target.value);
                        setIsValidEmail(validateEmail(e.target.value));
                    }}
                    error={ !isValidEmail }
                    helperText={!isValidEmail ? 'Illegal email' : ''}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setIsValidPassword(e.target.value !== '' && e.target.value.length >= 6);
                    }}
                    error={ !isValidPassword }
                    helperText={password === '' ? 'Password can not be empty!' : password.length < 6 ? 'Password must be at least 6 characters':''}
                />
                <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button type="submit">Add-user</Button>
                </DialogActions>
            </Box>
            </DialogContent>
        </Dialog>
        </div>
    );
}
